import { motion } from 'framer-motion';

import { iconsSources } from '../../helpers/icons';

import styles from './Photo.module.css';
import noLogoDefault from '../../assets/images/channel-none.png';
import { hideNumber } from '../../helpers/titreHelper';

export const Photo = ({ message, rotateSign, startDutation }) => {
  const errorHandler = (e) => {
    e.target.src = iconsSources[message?.channel] || noLogoDefault;
  };

  const srcAvatar =
    (message?.image !== '1' && message?.image) ||
    iconsSources[message?.channel];

  return (
    <div className={styles.photo} key={message.id}>
      <div className={styles.avatarBlock}>
        <div className={styles.avatar}>
          <img src={srcAvatar} alt={''} onError={errorHandler} />
        </div>

        <div className={styles.author}>
          {message?.author || hideNumber(message?.senderNumber)}
        </div>
      </div>

      <img
        src={message?.attachments[0].url}
        alt={''}
        className={styles.attach}
      />
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: [0, 0.6, 0] }}
        transition={{
          duration: startDutation,
          times: [0, 0.8, 1],
          ease: ['easeIn', 'easeOut'],
        }}
        className={styles.mask}
      />
    </div>
  );
};
